import "./index.scss";
import UsersList from "./UserList";
const Users = () => {
  return (
    <>
      <div className="main-contents">
        <UsersList />
      </div>
    </>
  );
};

export default Users;
